import './style.scss';

// GSAP
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin( ScrollTrigger );

const blueNavWidthRefresh = ( blueNav ) => {
	const w = blueNav.offsetWidth;
	document.documentElement.style.setProperty( '--blue-nav--width', `${w}px` );
}

document.addEventListener( 'DOMContentLoaded', () => {
	// Lazy load fade in
	document.querySelectorAll( 'img[loading="lazy"]' ).forEach( ( img ) => {
		if( img.complete === true ) {
			img.classList.add( 'has-loaded' );
		}
		img.addEventListener( "load", ( e ) => {
			e.target.classList.add( 'has-loaded' );
		} );
	} );

	// Copyright Year
	document.querySelectorAll(".copyright").forEach( ( p ) => { 
		p.innerHTML = p.innerHTML.replace( '{YEAR}', new Date().getUTCFullYear() );
	} );

	// Scroll shrink
	let mm = gsap.matchMedia();
	let previousProgress = 0;
	

	mm.add("(min-width: 1000px)", () => {
		document.querySelectorAll( "header.wp-block-template-part" ).forEach( block => {
			let offset = "5px";
			if( document.body.classList.contains( 'admin-bar' ) ) {
				const offsetValue = document.querySelector( '#wpadminbar' ).offsetHeight + 5;
				offset = offsetValue + "px";
			}
			console.log( offset );
			gsap.from( block, {
				scrollTrigger: {
					start: `200px ${offset}`,
					end: 'bottom 90%',
					trigger: document.querySelector( ".wp-site-blocks" ),
					onToggle: ( self ) => {
						if( self.progress === 0 || self.progress !== previousProgress ) {
							document.body.classList.toggle( 'slim-header', self.isActive );
							previousProgress = self.progress;
						}
					},
					// endTrigger: document.querySelector( ".wp-site-blocks" ),
					// toggleClass: 'slim-header',
					// markers: true,
				}
			});
		} )
	} );

	// Set blue nav global
	const blueNav = document.querySelector( ".wp-block-group.navigation-floating>.wp-block-group nav > ul" );
	if( blueNav ) {
		// init
		blueNavWidthRefresh( blueNav );
		window.addEventListener( "resize", () => {
			blueNavWidthRefresh( blueNav );
		} );		
	}
} );

